/**
 *
 * Asynchronously loads the component for Per003
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
